<template>
  <page-view :title="$t('appearance.title')" backLink="/dashboard" backText="Back to Dashboard" v-if="done">
    <template v-if="lvsEditor">
      <div class="d-f fd-c fd-md-r f-g">
        <card-link
          to="/appearance/lvsp"
          title="Player appearance"
          text="Customize fonts and colors to match your brand"
          backgroundColor="#B1E3FF"
          circleColor="#DAF1FF"
          icon="brush-24"
          v-if="lvsEditorAccessable"
        />
        <card-link
          to="/appearance/translations"
          title="Translations"
          text="Customize all the text that appears"
          backgroundColor="#7AD59D"
          circleColor="#96E4B4"
          icon="text-24"
          v-if="lvsEditorAccessable"
        />
        <card-link
          to="/appearance/play"
          title="Play site"
          text="Customize to match your brand"
          backgroundColor="#606D74"
          circleColor="#93A1A8"
          icon="play"
          v-if="playEditor"
        />
      </div>
    </template>
    <template v-else-if="lvsEditor && !lvsEditorAccessable">
      <div class="d-f f-1 ai-c jc-c">
        <div class="ta-c page-placeholder-text">
          <h2>Feature not included in your current plan</h2>
          <p>
            You can <a href="/settings/plan" @click.prevent="$router.push('/settings/plan')" class="link blue">manage your plan</a> to get access.
          </p>
        </div>
      </div>
    </template>
  </page-view>
</template>

<script>
export default {
  computed: {
    /**
     * Return boolean if play editor is enabled
     * @returns {Boolean}
     */
    playEditor() {
      return this.featuresEnabled.includes('ppv');
    },
    /**
     * Return boolean if lvs editor is enabled
     * @returns {Boolean}
     */
    lvsEditor() {
      return this.featuresEnabled.includes('lvs');
    },
    /**
     * Return boolean if lvs editor is accessable
     * @returns {Boolean}
     */
    lvsEditorAccessable() {
      const trialEnded = this.$store.getters['AccountManager/trialEnded'];
      const subscriptionEnded = this.$store.getters['AccountManager/subscriptionEnded'];

      if (trialEnded || subscriptionEnded) {
        return false;
      }

      return this.accountSettings?.shopping?.permissions?.appearance;
    },
  },
  data() {
    return {
      done: false,
    };
  },
  mounted() {
    const {
      playEditor,
      lvsEditorAccessable,
    } = this;

    if (playEditor && lvsEditorAccessable) {
      this.done = true;
      return;
    }

    if (playEditor && !lvsEditorAccessable) {
      this.$router.replace({ path: '/appearance/play' });
      return;
    }

    this.done = true;
  },
};
</script>
